module.exports = __webpack_public_path__ + "partylineManage/img/gimbal.6de99c1b.png";